


























































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { LectureSlideCreate as ILectureSlideCreate } from "@/api/models/lecture-slide-create";
import { LectureSlide as ILectureSlide } from "@/api/models/lecture-slide";
import { LectureSlideEdit as ILectureSlideEdit } from "@/api/models/lecture-slide-edit";
import FileManager from "@/components/files/FileManager.vue";
import api from "@/getinfo-api";
import draggableComponent from "vuedraggable";
import { FileItem as IFileItem } from "@/api/models/file-item";
import { uniqBy } from "lodash";
import EditorWithFile from "@/components/EditorWithFile.vue";

@Component({
  components: { EditorWithFile, draggableComponent, FileManager }
})
export default class LectureSlideCreate extends Vue {
  @Prop() lectureId!: string;
  @Prop() existSlides?: Array<ILectureSlide>;
  body: string | undefined = "";
  showAdditional: boolean = false;
  newSlides: any = [];
  startedSort: number = 0;
  index!: number | undefined;
  deleteSlideArray: Array<ILectureSlide> = [];
  selectedSlideId!: string | undefined;
  slideList!: string | undefined;
  usersFiles!: Array<IFileItem>;
  data() {
    return {
      index: undefined,
      selectedSlideId: undefined,
      slideList: undefined,
      usersFiles: []
    };
  }

  createSlide() {
    this.showAdditional = !this.showAdditional;
    this.$bvModal.show("slide-modal");
    this.usersFiles = [];
    this.body = "";
  }

  addFileToSlide(item: IFileItem) {
    if (item || !item) {
      if (!this.existSlides || this.existSlides) {
        this.usersFiles.push(item);
        this.usersFiles = uniqBy(this.usersFiles, item => {
          return item.id;
        });
      }
    }
  }

  applySort() {
    if (this.newSlides) {
      this.newSlides.forEach((element: ILectureSlideCreate, index: number) => {
        element.sort = index + 1;
      });
      this.$emit("sortSlide", this.newSlides);
    }
  }

  triggerEditSlideModal(item: any, index: number) {
    this.$bvModal.show("slide-modal");
    this.index = index;
    if (item.id) {
      this.selectedSlideId = item.id;
      api.LectureSlideApi.get(this.$route.params.id, item.id).then(
        (res: { data: ILectureSlide }) => {
          this.body = res.data.body ? res.data.body : "";
          if (res.data.images) {
            this.usersFiles = res.data.images;
          }
        }
      );
    } else {
      this.body = item.body ? item.body : "";
      this.usersFiles = item.images;
    }
  }

  filterPageBodyLength(lectureBody: string) {
    if (lectureBody?.length > 60) {
      return lectureBody?.substr(0, 50).replace(/(<(\/?[^>]+)>)/g, "") + "...";
    } else {
      return lectureBody ? lectureBody.replace(/(<(\/?[^>]+)>)/g, "") : "";
    }
  }

  deleteItem(item: any) {
    if (this.usersFiles?.length) {
      this.usersFiles = this.usersFiles?.filter(element => {
        return element !== item;
      });
    }
  }

  deleteSlide(slide: any) {
    if (slide.id) {
      this.deleteSlideArray.push(slide.id);
      this.$emit("slideToDelete", this.deleteSlideArray);
    }
    this.newSlides = this.newSlides.filter((element: any) => {
      return element != slide;
    });
    this.$emit("sortSlide", this.newSlides);
  }

  hideModal() {
    this.body = "";
    this.index = undefined;
    this.selectedSlideId = undefined;
  }

  editSlide() {
    if (this.selectedSlideId) {
      let params: ILectureSlideEdit = {
        body: this.body,
        images: this.usersFiles.map(el => el.id)
      };
      api.LectureSlideApi.edit(
        this.$route.params.id,
        this.selectedSlideId,
        params
      ).then(() => {
        this.selectedSlideId = undefined;
        this.usersFiles = [];
        this.$bvModal.hide("slide-modal");
      });
    }
  }

  addSlide() {
    if (this.body || this.usersFiles?.length) {
      let params: any = {
        body: this.body ? this.body : this.usersFiles[0].name,
        images: this.usersFiles ? this.usersFiles : undefined,
        sort: this.newSlides.length + 1
      };
      if (this.index === undefined) {
        this.newSlides.push(params);
      } else {
        this.newSlides.splice(this.index, 1, params);
      }

      this.usersFiles = [];
      this.startedSort += 1;
      this.body = "";
      this.index = undefined;
      this.selectedSlideId = undefined;
      this.$bvModal.hide("slide-modal");
      this.$emit("sortSlide", this.newSlides);
    } else {
      this.$bvToast.toast(this.$tc(this.$translate.ASlideCannotBeEmpty), {
        variant: "danger",
        title: this.$tc(this.$translate.Error)
      });
    }
  }

  mounted() {
    if (this.existSlides) {
      this.newSlides = this.existSlides;
    }
  }
}
